import React from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';

const OrderConfirmation = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Checkout पेज से जो आर्डर का डेटा आएगा, वो यहाँ मिलेगा
    const orderData = location.state?.orderData;

    // अगर कोई बिना आर्डर किये सीधा इस पेज पर आ जाए, तो उसे वापस होम पेज पर भेज देंगे
    if (!orderData) {
        return <Navigate to="/" />;
    }

    return (
        <div style={{ backgroundColor: '#f9f9f9', minHeight: '100vh',  fontFamily: 'Arial, sans-serif' }}>
            <div style={{ maxWidth: '600px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                
               {/* 1. Success Icon & Heading (Personalized with Name) */}
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <div style={{ backgroundColor: '#4caf50', color: '#fff', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px', fontSize: '30px' }}>
                        ✓
                    </div>
                    {/* 🟢 Personalized Greeting Here */}
                    <h2 style={{ margin: '0 0 10px', color: '#333', textTransform: 'capitalize' }}>
                        {orderData.name ? `${orderData.name}, ` : ""}Thank You!
                    </h2>
                    <h4 style={{ margin: '0 0 10px', color: '#4caf50' }}>Order Confirmed Successfully!</h4>
                    <p style={{ margin: '0', color: '#666' }}>Your order has been placed and is being processed.</p>
                </div>

                {/* 2. Order Details Box (Updated with Phone & Email) */}
                <div style={{ border: '1px solid #eaeaea', borderRadius: '8px', padding: '20px', marginBottom: '20px' }}>
                    <h4 style={{ margin: '0 0 15px', color: '#333' }}>Order Details</h4>
                    
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', color: '#555' }}>
                        <span>Order ID:</span>
                        <strong>#{orderData.id}</strong>
                    </div>

                    {/* 📞 Phone Number (Estimated Delivery ki jagah) */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', color: '#555' }}>
                        <span>Phone:</span>
                        <strong>{orderData.phone || 'N/A'}</strong>
                    </div>

                    {/* 📧 Email Address */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', color: '#555' }}>
                        <span>Email:</span>
                        <strong style={{ fontSize: '0.9rem' }}>{orderData.email || 'N/A'}</strong>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', color: '#555' }}>
                        <span>Payment Method:</span>
                        <strong>{orderData.paymentMethod || 'Online / COD'}</strong>
                    </div>
                </div>

                {/* 3. Item Details Box (Exactly matching your photo) */}
                <div style={{ marginBottom: '20px' }}>
                    <h4 style={{ margin: '0 0 10px', color: '#333', fontSize: '16px' }}>Your Order</h4>
                    <div style={{ border: '1px solid #eaeaea', borderRadius: '8px', padding: '15px', backgroundColor: '#fff', boxShadow: '0 2px 5px rgba(0,0,0,0.02)' }}>

                        {/* 🟢 Yahan loop chalega taaki customer ne jitne item liye hain sab dikhein */}
                        {orderData.items && orderData.items.map((item, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                {/* Product Image */}
                                <div style={{ width: '80px', height: '80px', backgroundColor: '#f5f5f5', borderRadius: '6px', marginRight: '15px', overflow: 'hidden', flexShrink: 0 }}>
                                    <img 
                                        src={item.image || item.productImage} 
                                        alt={item.productName || item.name} 
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                    />
                                </div>
                                {/* Product Name, Size & Qty */}
                                <div style={{ flex: 1 }}>
                                    <h5 style={{ margin: '0 0 8px', color: '#333', fontSize: '15px', fontWeight: 'bold' }}>
                                        {item.productName || item.name}
                                    </h5>
                                    <p style={{ margin: '0', color: '#555', fontSize: '13px', fontWeight: '500' }}>
                                        Size: {item.size} <span style={{ margin: '0 5px', color: '#ccc' }}>|</span> Qty: {item.qty}
                                    </p>
                                </div>
                            </div>
                        ))}

                        {/* Divider Line */}
                        <hr style={{ border: 'none', borderTop: '1px solid #eaeaea', margin: '15px 0' }} />

                        {/* Total Paid */}
                        <div style={{ textAlign: 'right' }}>
                            <h4 style={{ margin: '0', color: '#333', fontSize: '15px', fontWeight: 'bold' }}>
                                Total Amount: <span style={{ fontSize: '18px' }}>₹{orderData.totalAmount}</span>
                            </h4>
                        </div>
                    </div>
                </div>

                {/* 4. Shipping Address */}
                <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ margin: '0 0 10px', color: '#333' }}>Shipping Address</h4>
                    <p style={{ margin: '0', color: '#666', lineHeight: '1.5' }}>
                        <strong>{orderData.name || 'Customer'}</strong><br/>
                        {orderData.address}
                    </p>
                </div>

                {/* 5. Action Button (Track Order Hata Diya Gaya Hai) */}
                <button 
                    onClick={() => navigate('/')} 
                    style={{ width: '100%', padding: '15px', backgroundColor: '#fff', color: '#333', border: '1px solid #333', borderRadius: '6px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', marginBottom: '30px' }}
                >
                    Continue Shopping
                </button>

                {/* 6. Footer Quote */}
                <div style={{ textAlign: 'center', borderTop: '1px solid #eaeaea', paddingTop: '20px' }}>
                    <p style={{ fontStyle: 'italic', color: '#666', margin: '0 0 10px' }}>"We don't just deliver products, we deliver identity."</p>
                    <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 20px' }}>Antarvaani — Made in India Streetwear </p>
                    
                    <div style={{ color: '#666', fontSize: '14px' }}>
                        <p style={{ margin: '0 0 5px' }}>Need help?</p>
                        <p style={{ margin: '0' }}>✉️ contact@antarvaani.com &nbsp;&nbsp; &nbsp;  &nbsp;&nbsp;&nbsp;</p>
                        <p style={{ margin: '0' }}> 📞 +91 9310683989</p>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default OrderConfirmation;